import React from 'react';
import {
  IonHeader,
  IonToolbar,
  IonBackButton,
  IonButtons,
  IonMenuButton,
  IonTitle
} from '@ionic/react';

export default ({ title, defaultHref }) => {
  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonBackButton defaultHref={defaultHref || '/jobs'} />
        </IonButtons>
        <IonButtons slot="end">
          <IonMenuButton menu="mainMenu" />
        </IonButtons>
        <IonTitle>{title || 'Murphy'}</IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};
